/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTileCarousel_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_viewer">;
    readonly " $refType": "ItemTileCarousel_viewer";
};
export type ItemTileCarousel_viewer$data = ItemTileCarousel_viewer;
export type ItemTileCarousel_viewer$key = {
    readonly " $data"?: ItemTileCarousel_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTileCarousel_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemTileBase_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = 'b4bc1f667e73581081ae478b0c0948f4';
export default node;
